import React from 'react';
import Banners from '../modules/Banners/Banners'

function BannersPage(){
  return <Banners/>
}

export default BannersPage